import ContentWrapper from "./ContentWrapper";

// Transitional alias from before ContentWrapper itself was Mantine-based.
// Kept so existing imports keep working; new code should use ContentWrapper.
const ContentWrapperMantine = ContentWrapper;

export default ContentWrapperMantine;
